import {
  getServiceCollection,
  getServiceCollectionEligibilitySettings,
  putServiceCollectionEligibilitySettings,
} from "../../actions/api";
import React, { useEffect } from "react";
import { Breadcrumb, Button, Col, Form, Input, Row, Tooltip } from "antd";
import PropTypes from "prop-types";
import { connect, useSelector } from "react-redux";
import { ServiceHeader } from "../headers/PageHeaders";
import { ErrorBar } from "@authzsvc/common-react-components";
import { GroupFormItem, selectHasRole, RoleFormItem } from "./UtilsAdmin";
import { applicationPortal, service_admin_role } from "../../config";
import { useParams } from "react-router";
import { EditOutlined } from "@ant-design/icons";
import { NavLink } from "react-router-dom";
import { HelpCollectionEligibility } from "./help/HelpCollectionEligibility";

const ServiceCollectionEligibilitySettingsAdmin = ({
  getServiceCollection,
  getServiceCollectionEligibilitySettings,
  putServiceCollectionEligibilitySettings,
  serviceCollection,
  serviceCollectionEligibilitySettings,
  isLoading,
}) => {
  const { serviceCollectionId } = useParams();
  const isServiceAdmin = useSelector(selectHasRole(service_admin_role));
  const [form] = Form.useForm();
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  useEffect(() => {
    if (serviceCollectionEligibilitySettings)
      form.setFieldsValue(serviceCollectionEligibilitySettings);
  }, [form, serviceCollectionEligibilitySettings]);

  useEffect(() => {
    if (serviceCollection)
      getServiceCollectionEligibilitySettings(
        serviceCollection.applicationIdentifier,
      );
  }, [getServiceCollectionEligibilitySettings, serviceCollection]);

  useEffect(() => {
    getServiceCollection(serviceCollectionId);
  }, [getServiceCollection, serviceCollectionId]);

  const onFinish = async (values) => {
    await putServiceCollectionEligibilitySettings(serviceCollectionId, values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div>
      <Breadcrumb
        items={[
          {
            title: <NavLink to="/manage">Service Collections</NavLink>,
          },
          {
            title: `Eligibility Settings for ${serviceCollection?.applicationIdentifier}`,
          },
        ]}
      />
      <ServiceHeader
        title={serviceCollection?.displayName}
        subTitle={serviceCollection?.description}
        loading={isLoading}
      />

      {!isServiceAdmin && (
        <ErrorBar
          errors={[
            {
              title: "Access Denied.",
              data: {
                message:
                  "You are not administrator of this Service Collection.",
              },
            },
          ]}
          dismissError={() => {
            window.location.href = "/";
          }}
        />
      )}
      <Form
        disabled={!isServiceAdmin}
        hidden={!isServiceAdmin}
        {...layout}
        form={form}
        initialValues={serviceCollectionEligibilitySettings}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        style={{ maxWidth: 600, marginTop: "10px" }}
      >
        <Form.Item label="Application Identifier">
          <Row gutter={4}>
            <Col span={22}>
              <Input
                disabled
                value={serviceCollection?.applicationIdentifier}
              />
            </Col>
            <Col span={2}>
              <Tooltip title="Edit this Service Collection in the Application Portal">
                <Button
                  icon={<EditOutlined />}
                  href={`${applicationPortal}manage/${serviceCollection?.applicationIdentifier}`}
                  target="_blank"
                />
              </Tooltip>
            </Col>
          </Row>
        </Form.Item>

        <Form.Item label="ServiceId" name="serviceId" hidden>
          <Input disabled />
        </Form.Item>

        <RoleFormItem
          form={form}
          label="Eligible Role"
          name="eligibleRoleId"
          searchLabel="Select role used for Eligible people"
          applicationId={serviceCollectionId}
        />
        <RoleFormItem
          form={form}
          label="Eligible with Approval Role"
          name="eligibleWithApprovalRoleId"
          searchLabel="Select role used for Eligible with Approval people"
          applicationId={serviceCollectionId}
        />
        <Form.Item
          label="Approval Procedure Url"
          name="eligibilityApprovalProcedureUrl"
          tooltip="If set the Request button will go to the specified Url (SNOW Record Producer)"
        >
          <Input placeholder="Approval Procedure Url to a SNOW Record Producer" />
        </Form.Item>

        <GroupFormItem
          form={form}
          label="Eligible with Approval Group"
          name="approvedEligibilityGroupId"
          searchLabel="Select group used for Eligible Approval (and mapped to Eligible with Approval Role defined above)"
          applicationId={serviceCollectionId}
          roleId={serviceCollectionEligibilitySettings?.subscribedRoleId}
        />
        <RoleFormItem
          form={form}
          label="Subscribed Role"
          name="subscribedRoleId"
          searchLabel="Select role used for Subscribed people"
          applicationId={serviceCollectionId}
        />
        <GroupFormItem
          form={form}
          label="Self Subscription Group"
          name="selfSubscriptionGroupId"
          searchLabel="Select group used for Self Subscription (and mapped to Subscribed Role defined above)"
          applicationId={serviceCollectionId}
          roleId={serviceCollectionEligibilitySettings?.subscribedRoleId}
        />
        <RoleFormItem
          form={form}
          label="Admin Role"
          name="adminRoleId"
          searchLabel="Select role used for Admin people"
          applicationId={serviceCollectionId}
        />

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </Form.Item>
      </Form>

      <HelpCollectionEligibility />
    </div>
  );
};

ServiceCollectionEligibilitySettingsAdmin.propTypes = {
  getServiceCollection: PropTypes.func.isRequired,
  getServiceCollectionEligibilitySettings: PropTypes.func.isRequired,
  putServiceCollectionEligibilitySettings: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  serviceCollection: PropTypes.object,
  serviceCollectionEligibilitySettings: PropTypes.object,
};

//export default ServiceApplicationsList;
export default connect(
  (state) => ({
    serviceCollection: state.serviceCollection.data,
    serviceCollectionEligibilitySettings:
      state.serviceCollectionEligibilitySettings.data,
    isLoading: state.serviceApplications.loading,
  }),
  {
    getServiceCollection,
    getServiceCollectionEligibilitySettings,
    putServiceCollectionEligibilitySettings,
  },
)(ServiceCollectionEligibilitySettingsAdmin);
